<!--
  ~ Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
  ~ This software is released under MIT license.
  ~ The full license information can be found in LICENSE in the root directory of this project.
  -->

<div clrFocusTrap class="modal" *ngIf="_open">
  <!--fixme: revisit when ngClass works with exit animation-->
  <div
    [@fadeDown]="skipAnimation"
    (@fadeDown.done)="fadeDone($event)"
    class="modal-dialog"
    [class.modal-sm]="size == 'sm'"
    [class.modal-lg]="size == 'lg'"
    [class.modal-xl]="size == 'xl'"
    role="dialog"
    aria-modal="true"
    [attr.aria-hidden]="!_open"
    [attr.aria-labelledby]="labelledBy"
  >
    <div class="clr-sr-only">{{commonStrings.keys.modalContentStart}}</div>
    <div class="modal-content-wrapper">
      <!-- only used in wizards -->
      <ng-content select=".modal-nav"></ng-content>

      <div class="modal-content">
        <div class="modal-header--accessible">
          <div class="modal-title-wrapper" id="{{modalId}}" clrFocusOnViewInit>
            <ng-content select=".modal-title"></ng-content>
          </div>
          <button
            type="button"
            [attr.aria-label]="commonStrings.keys.close"
            class="close"
            *ngIf="closable"
            (click)="close()"
          >
            <cds-icon shape="window-close"></cds-icon>
          </button>
        </div>
        <div class="modal-body-wrapper">
          <ng-content select=".modal-body"></ng-content>
        </div>
        <ng-content select=".modal-footer"></ng-content>
      </div>
    </div>
    <div class="clr-sr-only">{{commonStrings.keys.modalContentEnd}}</div>
  </div>

  <div [@fade] class="modal-backdrop" aria-hidden="true" (click)="staticBackdrop || close()"></div>
</div>
